import { defineMessages } from 'react-intl';

/** Today's strings of the Social links and Profile blocks (design d6, d7 keep them). */
export const socialMessages = defineMessages({
  empty: {
    id: 'app.smart-links.widgets.social.empty',
    defaultMessage: 'No profiles yet. The block stays hidden on the page until you add one.',
  },
  openCatalog: { id: 'app.smart-links.widgets.social.open_catalog', defaultMessage: 'Open Catalog connections' },
  openChannels: { id: 'app.smart-links.widgets.social.open_channels', defaultMessage: 'Open Promote channels' },
  openArtistSettings: {
    id: 'app.smart-links.widgets.profile.open_artist_settings',
    defaultMessage: 'Change it in Settings → Artist',
  },
});
